import { PaymentElement } from '@stripe/react-stripe-js';
import React, { useState } from 'react';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import { css, StyleSheet } from 'aphrodite';
import { AppButton } from '../../../common/components/AppButton';
import { Helper } from '../../../common/helpers/Helper';
import { Checkbox } from '@material-ui/core';
import { AppConfig } from '../../../AppConfig';

export default function CheckoutForm(props) {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isPaymentConditionsChecked, setPaymentConditionsChecked] = useState(true);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsProcessing(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        /* eslint-disable camelcase */
        return_url: `${window.location.origin}/admin/advertisers/${props.orgId}/campaigns/${props.campaignId}/pg`,
      },
    });

    if (error.type === 'card_error' || error.type === 'validation_error') {
      setMessage(error.message);
    } else {
      setMessage(error.msg || Helper.getString('customerCareErr'));
    }

    setIsProcessing(false);
  };

  const handleCheckBoxClick = (e) => {
    setPaymentConditionsChecked(e.target.checked)
  }

  const renderCheckbox = () => {
    return (
      <div className={css(Styles.paymentConditionContainer)}>
        <Checkbox
          key={'isPaymentConditionsChecked'}
          name={'isPaymentConditionsChecked'}
          id={'isPaymentConditionsChecked'}
          onChange={(e) => handleCheckBoxClick(e)}
          checked={isPaymentConditionsChecked}
          value={isPaymentConditionsChecked}
          classes={{
            root: css(Styles.checkBoxRoot),
            checked: css(Styles.checkboxChecked)
          }}
        />
        <p className={css(Styles.paymentConditionText)}>{Helper.getString('paymentConditions')}</p>
      </div>
    )

  }

  const btnDisabled = isProcessing || !stripe || !elements || !isPaymentConditionsChecked

  return (
    <form id='payment-form' className={css(Styles.formContainer)}>
      <PaymentElement />
      {/* <button disabled={isProcessing || !stripe || !elements} id='submit'>
        <span id='button-text'>
          {isProcessing ? 'Processing ... ' : 'Pay now'}
        </span>
      </button> */}
      <div className={css(Styles.buttonContainer)}>
        {message && <div id='payment-message' className={css(Styles.message)}>{message}</div>}
        {renderCheckbox()}
        <AppButton
          id='submit'
          disabled={btnDisabled}
          inProcess={isProcessing}
          onClick={handleSubmit}
          buttonText={'Subscribe (Monthly Auto Pay)'}
          buttonStyle={btnDisabled ? Styles.buttonStyle : null}
          buttonTextStyle={btnDisabled ? Styles.buttonTextStyle : null}
          progressIcon={btnDisabled ? Styles.progressIcon : null}
        />
      </div>
      {/* Show any error or success messages */}
    </form>
  );
}

const Styles = StyleSheet.create({
  buttonContainer: {
    marginTop: 5,
    marginBottom: 30,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    alignSelf: 'flex-end',
    flex: 1
  },
  message: {
    marginRight: 15,
    color: 'red'
  },
  checkBoxRoot: {
    color: '#747474',
    padding: 0
  },
  checkboxChecked: {
    color: AppConfig.TINT_COLOUR
  },
  paymentConditionContainer: {
    display: 'flex',
    gap: 10
  },
  paymentConditionText: {
    fontSize: 14,
    color: AppConfig.TINT_COLOUR
  },
  buttonStyle: {
    backgroundColor: '#f5f5f5'
  },
  buttonTextStyle: {
    color: '#a9a9a9'
  },
  formContainer: {
    minHeight: 500,
    display: 'flex',
    flexDirection: 'column'
  },
  progressIcon: {
    color: AppConfig.TINT_COLOUR
  }
})


// WEBPACK FOOTER //
// ./src/components/advertiser/stripe/CheckoutForm.js